import { twoXKO_metablob_v1 } from './v1';

export function createTwoXKOMetablob(metadata: Record<string, string>): twoXKO_metablob_v1 | null {
  try {
    return {
      metablobVersion: 'twoXKO_metablob_v1',
      assistChampion: metadata.assistChampion || '',
      fuse: metadata.fuse || '',
      pointChampion: metadata.pointChampion || '',
    };
  } catch (error) {
    console.error('Failed to create 2xKO metablob:', error);
    return null;
  }
}

export function parseTwoXKOMetablob(metablob: string | undefined): twoXKO_metablob_v1 | undefined {
  if (!metablob) return undefined;
  try {
    const parsed = JSON.parse(metablob);
    return parsed?.metablobVersion === 'twoXKO_metablob_v1' ? (parsed as twoXKO_metablob_v1) : undefined;
  } catch {
    return undefined;
  }
}
